module.exports = __webpack_public_path__ + "img/redDown.e9a63dee.svg";